import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "features" }
const _hoisted_4 = { class: "feature" }
const _hoisted_5 = { class: "image-wrapper" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "feature" }
const _hoisted_8 = { class: "image-wrapper" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "feature" }
const _hoisted_11 = { class: "image-wrapper" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "feature" }
const _hoisted_14 = { class: "image-wrapper" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "subscription-options" }
const _hoisted_17 = { class: "subscription-option" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { for: "monthly" }
const _hoisted_20 = { class: "subscription-title" }
const _hoisted_21 = { class: "subscription-option" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { for: "yearly" }
const _hoisted_24 = { class: "subscription-title" }

import { computed, ref, onBeforeMount, Ref } from "vue";
import {
  COUNTRIES_CURRENCY,
  DEFAULT_COUNTRY_ISO,
  SUBSCRIPTION_MODELS,
} from "../../assets/constants";
import { makeMPServerRequest } from "../../assets/helpers";
import { useStore } from "vuex";
import RoundedButton from "../RoundedButton.vue";
import IconButton from "../IconButton.vue";
import PaySubscriptionModal from "./PaySubscriptionModal.vue";

interface Props {
  visible: boolean;
  setVisible: Function;
  modal: boolean;
}

type SubscriptionModelTypes = typeof SUBSCRIPTION_MODELS;
type SubscriptionTypes =
  SubscriptionModelTypes[keyof SubscriptionModelTypes]["type"];


export default /*@__PURE__*/_defineComponent({
  __name: 'PaywallModal',
  props: {
    visible: { type: Boolean },
    setVisible: { type: Function },
    modal: { type: Boolean }
  },
  emits: ["subscriptionSuccess"],
  setup(__props: any, { emit: __emit }) {

const PersonWithPigeonBalloon =
  require("../../assets/images/Person-with-pigeon-balloon.png") as string;
const MicIcon = require("../../assets/images/MicIcon.svg") as string;
const WandIcon = require("../../assets/images/Magic-wand-white.svg") as string;
const CaptioningNotesIcon =
  require("../../assets/images/MicIcon.svg") as string;
const NotesIcon = require("../../assets/images/Notes-white.svg") as string;
const CloseGreyIcon = require("../../assets/images/Close-grey.svg") as string;

const props = __props;
const store = useStore();
const emit = __emit;

const monthlySubscriptionPrice: Ref<number | null> = ref(null);
const yearlySubscriptionPrice: Ref<number | null> = ref(null);
const selectedSubscriptionType: Ref<SubscriptionTypes> = ref(
  SUBSCRIPTION_MODELS.MONTHLY.type
);
const showPaymentModal = ref(false);

onBeforeMount(async () => {
  const myHeaders = new Headers();
  myHeaders.append(
    "Authorization",
    `Bearer ${JSON.parse(localStorage.getItem("tokenMP") || "").accessToken}`
  );

  const subscriptionPrices = await makeMPServerRequest(
    "self/stripe-subscription-prices",
    "GET",
    "json",
    null
  );

  monthlySubscriptionPrice.value =
    subscriptionPrices.data.monthly.unit_amount_decimal / 100;
  yearlySubscriptionPrice.value =
    subscriptionPrices.data.yearly.unit_amount_decimal / 100;
});

function formattedSubscriptionPrice(price: number | null): string {
  return price === null
    ? "Issue retrieving subscription prices"
    : currencySymbol.value + price.toString();
}

function setShowPaymentModal(bool: boolean) {
  showPaymentModal.value = bool;
}

function onSubscriptionSuccess() {
  emit("subscriptionSuccess");
  props.setVisible(false);
}

/***** Computed values *****/
const currentUserCountryISO = computed(() => {
  return store.state.user.currentUser.location || DEFAULT_COUNTRY_ISO;
});

const currencySymbol = computed(() => {
  return COUNTRIES_CURRENCY[
    currentUserCountryISO.value as keyof typeof COUNTRIES_CURRENCY
  ].symbol;
});

const formattedSelectedSubscriptionPrice = computed(() => {
  return formattedSubscriptionPrice(
    selectedSubscriptionType.value === SUBSCRIPTION_MODELS.MONTHLY.type
      ? monthlySubscriptionPrice.value
      : yearlySubscriptionPrice.value
  );
});
/***** End of computed values *****/

return (_ctx: any,_cache: any) => {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      visible: props.visible,
      modal: props.modal,
      class: "paywall-modal",
      closable: false
    }, {
      header: _withCtx(() => [
        _createVNode(IconButton, {
          icon: _unref(CloseGreyIcon),
          class: "close-button",
          alt: "Close dialog",
          onclick: 
          () => {
            _ctx.setVisible(false);
          }
        ,
          xsmall: ""
        }, null, 8, ["icon", "onclick"]),
        _cache[3] || (_cache[3] = _createElementVNode("h1", null, "Get full access", -1)),
        _createElementVNode("img", {
          src: _unref(PersonWithPigeonBalloon),
          class: "header-image"
        }, null, 8, _hoisted_1)
      ]),
      footer: _withCtx(() => [
        _createVNode(RoundedButton, {
          text: "Start Plan",
          lessRound: "",
          accent: "",
          fitWidth: "",
          uppercase: "",
          onClick: _cache[2] || (_cache[2] = 
          () => {
            setShowPaymentModal(true);
          }
        )
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: _unref(MicIcon),
                  alt: "Microphone"
                }, null, 8, _hoisted_6)
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "feature-text" }, [
                _createElementVNode("p", { class: "feature-title" }, "Unlimited Audio Recording"),
                _createElementVNode("p", { class: "feature-description" }, " Record or upload without limits and capture every moment on our cloud ")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: _unref(WandIcon),
                  alt: "Magic wand"
                }, null, 8, _hoisted_9)
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "feature-text" }, [
                _createElementVNode("p", { class: "feature-title" }, "Study Assistant"),
                _createElementVNode("p", { class: "feature-description" }, " Access to insightful analysis, keywords, and quizzes to enhance your learning ")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("img", {
                  src: _unref(CaptioningNotesIcon),
                  alt: "Captioning"
                }, null, 8, _hoisted_12)
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "feature-text" }, [
                _createElementVNode("p", { class: "feature-title" }, "Live Captioning"),
                _createElementVNode("p", { class: "feature-description" }, " Enhance accessibility and understanding with real-time transcriptions during lectures ")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("img", {
                  src: _unref(NotesIcon),
                  alt: "Notes"
                }, null, 8, _hoisted_15)
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "feature-text" }, [
                _createElementVNode("p", { class: "feature-title" }, "Personal Notes"),
                _createElementVNode("p", { class: "feature-description" }, " Seamlessly add your own insights and comments while recording or viewing live captions ")
              ], -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: "monthly",
                name: "subscriptionType",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedSubscriptionType).value = $event)),
                value: _unref(SUBSCRIPTION_MODELS).MONTHLY.type
              }, null, 8, _hoisted_18), [
                [_vModelRadio, selectedSubscriptionType.value]
              ]),
              _createElementVNode("label", _hoisted_19, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(currencySymbol.value + monthlySubscriptionPrice.value + " / month"), 1),
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "subscription-description" }, "Charged monthly after 30-day free trial", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: "yearly",
                name: "subscriptionType",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedSubscriptionType).value = $event)),
                value: _unref(SUBSCRIPTION_MODELS).YEARLY.type
              }, null, 8, _hoisted_22), [
                [_vModelRadio, selectedSubscriptionType.value]
              ]),
              _createElementVNode("label", _hoisted_23, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "save-more-label" }, "Save More + Get 1 Month Free", -1)),
                _createElementVNode("span", _hoisted_24, _toDisplayString(currencySymbol.value + yearlySubscriptionPrice.value + " / year"), 1),
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "subscription-description" }, "Charged yearly after 30-day free trial", -1))
              ])
            ])
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("p", { class: "cancel-anytime" }, "Cancel anytime", -1))
        ])
      ]),
      _: 1
    }, 8, ["visible", "modal"]),
    _createVNode(PaySubscriptionModal, {
      visible: showPaymentModal.value,
      setVisible: setShowPaymentModal,
      formattedSelectedSubscriptionPrice: formattedSelectedSubscriptionPrice.value,
      selectedSubscriptionType: selectedSubscriptionType.value,
      onSubscriptionSuccess: onSubscriptionSuccess
    }, null, 8, ["visible", "formattedSelectedSubscriptionPrice", "selectedSubscriptionType"])
  ], 64))
}
}

})